// extracted by mini-css-extract-plugin
export var button = "_6e-4";
export var hasDarkBackground = "_6e-7";
export var hasLightBackground = "_6e-6";
export var iconWrapper = "_6e-0";
export var large = "_6e-2";
export var medium = "_6e-1";
export var small = "_6e-5";
export var xsmall = "_6e-3";